export default function SettlementFieldList({ items = [], columns = 2 }) {
  const rows = (items || []).filter((item) => item && item.label);
  if (!rows.length) return null;

  return (
    <dl
      className={`grid gap-x-6 gap-y-1.5 ${
        columns === 2 ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1'
      }`}
    >
      {rows.map((item) => (
        <div
          key={item.label}
          className={`min-w-0 flex items-baseline gap-2 ${item.span === 2 ? 'sm:col-span-2' : ''}`}
        >
          <dt className="text-[11px] font-medium uppercase tracking-wide text-gray-500 shrink-0">
            {item.label}
          </dt>
          <dd
            className={`text-sm text-gray-900 break-words min-w-0 ${
              item.mono ? 'tabular-nums font-medium' : 'font-medium'
            } ${item.className || ''}`}
          >
            {item.value ?? '—'}
          </dd>
        </div>
      ))}
    </dl>
  );
}
